import api from "./api";

export const getCollaboratosAll = async () => {
    const response = await api.get(`collaborator/listAll`);
    return response.data;
};

export const postEmailsUC = async (body: any) => {
    const response = await api.post(`emailsRedirectUC/`, body);
    return response.data;
};

export const updateEmailUC = async (body: any, id: string) => {
    const response = await api.put(`emailsRedirectUC/${id}`, body);
    return response.data;
};

export const deleteEmailUC = async (id: string) => {
    const response = await api.delete(`emailsRedirectUC/${id}`);
    return response.data;
};

export const getClientOne = async (id: string) => {
    const response = await api.get(`client/${id}`);
    return response.data;
};

